import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import MultiActionAreaCard from './MultiActionAreaCard';
import ClientProvider from './client';
export default createDemo(import.meta.url, MultiActionAreaCard, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/cards/demos/multi-action-area/MultiActionAreaCard.tsx",
    "fileName": "MultiActionAreaCard.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Card from '@mui/material/Card';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport CardActionArea from '@mui/material/CardActionArea';\nimport CardActions from '@mui/material/CardActions';\n\nexport default function MultiActionAreaCard() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Card sx={{ maxWidth: 345 }}>\n      <CardActionArea>\n        <CardMedia\n          component=\"img\"\n          height=\"140\"\n          image=\"/static/images/cards/contemplative-reptile.jpg\"\n          alt=\"green iguana\"\n        />\n        <CardContent>\n          <Typography gutterBottom variant=\"h5\" component=\"div\">\n            Lizard\n          </Typography>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            Lizards are a widespread group of squamate reptiles, with over 6,000\n            species, ranging across all continents except Antarctica\n          </Typography>\n        </CardContent>\n      </CardActionArea>\n      <CardActions>\n        <Button size=\"small\" color=\"primary\">\n          Share\n        </Button>\n      </CardActions>\n    </Card>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 36,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Card from '@mui/material/Card';\nimport CardContent from '@mui/material/CardContent';\nimport CardMedia from '@mui/material/CardMedia';\nimport Typography from '@mui/material/Typography';\nimport Button from '@mui/material/Button';\nimport CardActionArea from '@mui/material/CardActionArea';\nimport CardActions from '@mui/material/CardActions';\n\nexport default function MultiActionAreaCard() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Card sx={{ maxWidth: 345 }}>\n      <CardActionArea>\n        <CardMedia\n          component=\"img\"\n          height=\"140\"\n          image=\"/static/images/cards/contemplative-reptile.jpg\"\n          alt=\"green iguana\"\n        />\n        <CardContent>\n          <Typography gutterBottom variant=\"h5\" component=\"div\">\n            Lizard\n          </Typography>\n          <Typography variant=\"body2\" sx={{ color: 'text.secondary' }}>\n            Lizards are a widespread group of squamate reptiles, with over 6,000\n            species, ranging across all continents except Antarctica\n          </Typography>\n        </CardContent>\n      </CardActionArea>\n      <CardActions>\n        <Button size=\"small\" color=\"primary\">\n          Share\n        </Button>\n      </CardActions>\n    </Card>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 36,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Card",
      "@mui/material/CardContent",
      "@mui/material/CardMedia",
      "@mui/material/Typography",
      "@mui/material/Button",
      "@mui/material/CardActionArea",
      "@mui/material/CardActions"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
